import { SelectionModel } from '@angular/cdk/collections';
import { AfterViewInit, Component, ElementRef, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { EstateControlService } from 'src/app/services/estate-control.service';
import { PDFService } from 'src/app/services/PDF/pdfservice.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-checklist',
  templateUrl: './checklist.component.html',
  styleUrls: ['./checklist.component.scss']
})
export class ChecklistComponent implements AfterViewInit {
  @ViewChild('pdfContent', { static: false }) pdfContent!: ElementRef;

  checkListType: 'trust' | 'estate' = 'trust';

  logoPath: string  = `${environment.hRef}assets/logo-trust.png`;

  checklistTitles: string[] = [
    'No.', 'Document', 'Party Responsible', 'Status / Comments', 'Tick once done'
  ];

  checkListFamilyTrust: any[] = [];

  tableColumns: string[] = [];
  tableData: any[]= [];
  tableDataSource!: MatTableDataSource<any>;

  // Checkbox
  selection = new SelectionModel<any>(true, []);


  constructor(
    private estateControlService: EstateControlService,
    private pdfService: PDFService
  ) { }


  async ngAfterViewInit(): Promise<void> {
    if (this.pdfContent) {
      // const data = await this.estateControlService.getData(this.estateControlService.storageKey);
      // if (data) {
      //   await this.estateControlService.updateDataFromStorage();
      // }
      this.loadTable();
      this.pdfService.setChecklistPdfContent(this.pdfContent);
    }
  }

  get settlors() {
    return this.estateControlService.settlors;
  }

  get activeTab() {
    return this.estateControlService.activeTab;
  }

  loadTable(): void {
    this.checkListFamilyTrust = [
      { no: 1, document: 'Preparation of Trust Deed', partyResponsible: 'Settlor', statusComments: '', tick: (this.activeTab > 1 ? true : false) },
      { no: 2, document: 'Preparation of Petition for incorporation', partyResponsible: 'Trustee', statusComments: '', tick: (this.activeTab > 5 ? true : false) },
      { no: 3, document: 'Diagrammatic representation of the seal', partyResponsible: 'Settlor', statusComments: '', tick: (this.activeTab > 1 ? true : false) },
      { no: 4, document: 'Abstract and Minutes appointing the trustees', partyResponsible: 'Settlor / Trustee', statusComments: '', tick: (this.activeTab > 5 ? true : false) },
      { no: 5, document: 'Copy of title / lease agreement for the trust (Schedule to be completed in the estate planning information form)', partyResponsible: 'Settlor', statusComments: '', tick: false },
      { no: 6, document: 'Official search of the title documents', partyResponsible: 'Settlor / Trustee', statusComments: '', tick: false },
      { no: 7, document: 'Trust Bank Statement', partyResponsible: 'Settlor', statusComments: '', tick: false },
      { no: 8, document: 'Trust Financial Statement', partyResponsible: 'Settlor', statusComments: '', tick: (this.activeTab > 2 ? true : false) },
      { no: 9, document: 'Statement of donor funding / commitment', partyResponsible: 'Settlor', statusComments: '', tick: (this.activeTab > 2 ? true : false) },
      { no: 10, document: 'Curriculum Vitae for the trustees or employees', partyResponsible: 'Settlor / Trustee', statusComments: '', tick: (this.activeTab > 5 ? true : false) },
      { no: 11, document: 'National Identity Cards / Passports for the trustees / founders', partyResponsible: 'Settlor', statusComments: '', tick: (this.activeTab > 5 ? true : false) },
      { no: 12, document: 'KRA PIN for Trustees and Founders', partyResponsible: 'Settlor', statusComments: '', tick: (this.activeTab > 5 ? true : false) },
      { no: 13, document: 'Passport photos for trustees and founders', partyResponsible: 'Settlor / Trustee', statusComments: '', tick: (this.activeTab > 5 ? true : false) }
    ];
    this.tableData = this.checkListFamilyTrust;   
    this.tableDataSource = new MatTableDataSource<any>(this.tableData);

    // Initialize the selection model based on the `tick` values
    this.selection.clear();
    this.checkListFamilyTrust.forEach(row => {
      if (row.tick) {
        this.selection.select(row);
      }
    });

    // Update displayedColumns based on the dataSource
    if (this.tableData.length === 0) {
      this.tableDataSource = new MatTableDataSource<any>([]); // Empty data source for no records
      this.tableColumns = []; // Clear columns if there's no data

    } else {
      this.tableColumns = Object.keys(this.tableDataSource.data[0]).filter(
        key =>
          this.tableDataSource.data[0][key] !== null
       );
      this.tableColumns = this.formatHeaders(this.tableColumns);
    }
  }

  formatHeaders(columns: string[]): string[] {
    return columns.map(column => {
      // Convert 'camelCase' to 'Proper Case'
      return column.replace(/([a-z])([A-Z])/g, '$1 $2').replace(/\b\w/g, char => char.toUpperCase());
    });
  }
  getColumnName(header: string, originalColumns: any[]): string {
    const firstOriginalColumn = Object.keys(originalColumns[0]);
    // If the first letter of the first column is lowercase, return the converted result in camelCase
    if (firstOriginalColumn[0] === firstOriginalColumn[0].toLowerCase()) {
      return header
        .replace(/\s(.)/g, (_, match) => match.toUpperCase()) // Capitalize letters after spaces
        .replace(/\s/g, '')  // Remove spaces
        .replace(/^\w/, c => c.toLowerCase());
    } else {
      return header
        .replace(/\s(.)/g, (_, match) => match.toUpperCase()) // Capitalize letters after spaces
        .replace(/\s/g, '')  // Remove spaces
        .replace(/^\w/, c => c.toUpperCase());  // Capitalize the first letter
    }
  }

  toggleRow(row: any) {
    this.selection.toggle(row);
    row.tick = this.selection.isSelected(row); // Update the `tick` value in the data source
  }
}
